module.exports = __webpack_public_path__ + "img/search-small.9c648590.svg";